'use strict'

import Model from './model'
import Config from '../../config'
import ILanguage from '../interfaces/ILanguage';
import IProject from '../interfaces/IProject';


/**
 * View for component Project List
 * @param project
 * @returns html view for component Project List
 */



class View {

  renderLanguages(languages: ILanguage[]) {

    //console.log('project', project)

    document.title = `${Config.siteName} | Projects`;

    if(languages.length === null || languages === undefined){
      return;
    }
    
const languagesMarkup = `
    ${languages.map((language: ILanguage) => {      
      if(         
         language.name === 'C'
      || language.name === 'CSS'
      || language.name === 'C++'   
      || language.name === 'CMake'      
      || language.name === 'HTML' 
      || language.name === 'Java'
      || language.name === 'JavaScript'
      || language.name === 'MATLAB'
      || language.name === 'Saas'      
      || language.name === 'SCSS'
      || language.name === 'Shell'
      || language.name === 'Python'
      || language.name === 'TypeScript'
    ){
      return `
        <div class="relative" style="right: 0px;margin-bottom: -35px;">        				
          ${Config.languageToSVG[language.name as keyof typeof Config.languageToSVG]}
          <br/>
        </div>
      `
    }}
    ).join('')}
    `;
    return languagesMarkup;
}

  async appendProjectsList (projects: IProject[]) {
    
    //console.log('projects', projects)    

        // if articlesList is null or undefined
        if (projects === null || projects === undefined) {
          return /* html */`
          <div class="container mx-auto px-4 sm:px-8 font-sans text-base antialiased leading-7 z-0">              
              <article>
                <div class="pt-6 pb-4 flex-shrink-0 border-b border-gray-200 dark:border-gray-700">
                  <p class="text-[11px] font-bold uppercase tracking-widest opacity-50">Projects</p>
                </div>
                <ul>
                  <li class=" text-blue-400 hover:font-bold">
                    <a href="/Error502">
                      No articles available
                    </a>                      
                  </li>
                </ul>
              </article>
            </div>
          `
        }
    const view = await /* html */`                                                                  
                  <!-- Projects content -->                                    
                    <div class="mx-5 font-sans text-base antialiased leading-7 z-0">                    
                          <article>
                            <div class="pt-6 pb-4 flex-shrink-0 border-b border-gray-200 dark:border-gray-700">
                              <p class="text-[11px] font-bold uppercase tracking-widest opacity-50">Projects</p>
                            </div>
                                                                            
                            <ul class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-6 w-full mt-5">
                            
                            ${projects.map((project: any) => /* html */`                                                        
                                  <li class="w-full flex justify-center">                          
                                    <div class="shadow-lg hover:shadow-md  
                                      light:bg-light-background dark:bg-dark-background                                      
                                      rounded-lg overflow-hidden relative w-full mb-5" 
                                      style="height: 400px; min-width: 180px; max-width: 320px; border: 1px solid #e2e8f0;">
                                      <img
                                        class="object-cover w-full h-48"
                                        src="${project.openGraphImageUrl}"
                                        alt="${project.name}"/>
                                        
                                        <div class="absolute" style="top: 0px; right: 0px;">
                                          ${this.renderLanguages(project.languages)}
                                        </div>

                                        ${project.stargazers != 0 ? (                                       `
                                          <div>
                                            <div class="absolute" style="top: -10px; left: -8px;">
                                              <div class="relative">
                                                
                                                <svg width="64px" height="64px" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="m7.68 26.92a81.36 81.36 0 0 1 9.32-3.35 46.42 46.42 0 0 1 5.66-1.06s2.28-5.09 3.59-7.66 2.16-4.28 3.6-4.43 4.31 4.43 5.71 6.84 2.6 4.41 2.6 4.41 9.72.9 13.22 1.06 4.78.25 5.15 1.19-8 7-9.68 8.31a21.53 21.53 0 0 0 -2.69 2.5s1.78 6.4 2.94 11.06 1.65 6.41 1.12 7.31-2.16.41-3.56-.37-7.56-4.78-9.88-6.1-3.18-1.21-3.34-1.18-8.81 4.62-11.56 6.15-4.26 1.57-4.88 1.4-.31-1.78-.09-3 3.69-13.6 3.69-13.78a44.64 44.64 0 0 0 -7-5.57c-2.6-1.65-3.54-2.05-3.76-2.23s-.66-1.29-.16-1.5z" fill="#1d1d1b"/>
                                                  <path d="m10.87 27.45c.21-.35 6.44-2.38 9.22-3s3.28-.56 3.43-.69 2.82-5.59 4.19-8.12 1.88-3.16 2.1-3.16a81.12 81.12 0 0 1 5.19 7.72c1.27 2.25 1.52 2.8 1.71 2.8s9.35.81 12.5 1 4.63.41 4.5.63-5.47 4.12-8 6.31-3.71 2.98-3.65 3.35 1.53 6.38 1.43 6.31a25.89 25.89 0 0 0 -3.49-1.6c-.12.12-.65.84-.4 1.09s4.12 2 4.12 2.19.32 1.69.32 1.69-5.25-3-5.47-3-.88.56-.72.78 6.31 3.56 6.47 3.78a5.48 5.48 0 0 1 .56 1.53c-.09 0-7.72-4.5-8-4.44s-.75.94-.66 1 8.91 5.19 9.07 5.44.87 2 .68 2-7.59-4.34-10.4-5.9-3.47-1.79-4-1.75a121.69 121.69 0 0 0 -11.47 5.75c-2.16 1.31-3 1.56-3.07 1.4s2.44-10.06 3-12.5.79-2.87.16-3.65a27.46 27.46 0 0 0 -5.47-4.22c-2.6-1.62-3.95-2.59-3.85-2.74z" fill="#fab900"/><path d="m27.06 21c-.33-.33 2.18-4.69 2.31-4.69s.81.16.87.41a32.48 32.48 0 0 1 -2 4.72 3.18 3.18 0 0 1 -1.18-.44z" fill="#1d1d1b"/>
                                                </svg>						
                                                                                              
                                              </div>	
                                            </div>
                                            
                                            <div class="absolute" style="top: 0px; left:0;">
                                              <div class="relative">
                                                <div class="my-4 mx-5 text-xs underline subpixel-antialiased text-black font-semibold">
                                                  ${project.stargazers}
                                                </div>						
                                              </div>
                                            </div>

                                          </div>`

                                        ):("")}

                                        <div class="relative p-4 h-60 max-h-60">
                                          <h1 class="text-base font-medium underline decoration-pink-500 -mt-3 -mb-3">
                                            ${project.name}
                                          </h1>
                                          <p class="mt-4 text-xs font-bold mb-1">
                                            updated: ${new Date(project.pushedAt).getDate()}-
                                                     ${new Model().getMonth(new Date(project.pushedAt).getMonth())}-
                                                     ${new Date(project.pushedAt).getFullYear()}
                                          </p>

                                          <p class="inline-flex items-center">
                                            <a
                                              class="text-[11px] font-sans font-medium border border-slate-300 dark:border-slate-600 text-slate-600 dark:text-slate-300 px-2 py-0.5 rounded-full hover:border-blue-400 hover:text-blue-500 transition-colors whitespace-nowrap"
                                              href="${"https://github.com" + project.resourcePath}">
                                              Source
                                              <i class="bi bi-github"></i>
                                            </a>
                                            &nbsp;
                                            ${project.homepageUrl === "" ||
                                            project.homepageUrl == null ? (
                                            ""
                                            ) : (
                                              `
                                            <a
                                              class="text-[11px] font-sans font-medium border border-blue-300 dark:border-blue-700 text-blue-500 dark:text-blue-400 px-2 py-0.5 rounded-full hover:border-blue-500 hover:text-blue-600 transition-colors whitespace-nowrap"
                                              href="${project.homepageUrl}">
                                              Show Web
                                              <i class="bi bi-browser-chrome"></i>
                                            </a>`
                                            )}
                                          </p>
                                          <p class="mt-2 text-sm">
                                            ${project.description}
                                          </p>                                        
                                        </div>
                                                                                                                      
                                    </div>
                                  </li>
                                    `              
                                    ).join('')}                                
                            </ul>
                          </article>                      
                        </div>                                              
                    `
    return view
  }
}

export default View